import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'

/**
 * @typedef {Object} AddressGroup
 * @property {Id}       [addressGroupId]    - The id of the address group.
 * @property {string}   [addressGroupInfo]  - The information detail of the address group.
 * @property {string}   [addressGroupName]  - The name of the address group.
 */

export const addressGroupPropType = PropTypes.shape({
    addressGroupId: idPropType,
    addressGroupInfo: PropTypes.string,
    addressGroupName: PropTypes.string
})
